/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Authentication } from './Authentication';
import {
    AuthenticationFromJSON,
    AuthenticationFromJSONTyped,
    AuthenticationToJSON,
} from './Authentication';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonType } from './PersonType';
import {
    PersonTypeFromJSON,
    PersonTypeFromJSONTyped,
    PersonTypeToJSON,
} from './PersonType';

/**
 * 
 * @export
 * @interface UserTokenAllOf
 */
export interface UserTokenAllOf {
    /**
     * 
     * @type {string}
     * @memberof UserTokenAllOf
     */
    prev_token_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTokenAllOf
     */
    oid?: string;
    /**
     * Person ID
     * @type {string}
     * @memberof UserTokenAllOf
     */
    person_id?: string;
    /**
     * 
     * @type {PersonType}
     * @memberof UserTokenAllOf
     */
    person_type?: PersonType;
    /**
     * 
     * @type {boolean}
     * @memberof UserTokenAllOf
     */
    first_token?: boolean;
    /**
     * 
     * @type {Array<Authentication>}
     * @memberof UserTokenAllOf
     */
    authentications?: Array<Authentication>;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof UserTokenAllOf
     */
    authenticated_methods?: Array<FactorMethod>;
    /**
     * 
     * @type {string}
     * @memberof UserTokenAllOf
     */
    groups_claim_name?: string;
    /**
     * The ID of the anonymous person used before the sign-in (if any)
     * @type {string}
     * @memberof UserTokenAllOf
     */
    prev_anonymous_person_id?: string;
}

/**
 * Check if a given object implements the UserTokenAllOf interface.
 */
export function instanceOfUserTokenAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserTokenAllOfFromJSON(json: any): UserTokenAllOf {
    return UserTokenAllOfFromJSONTyped(json, false);
}

export function UserTokenAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTokenAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prev_token_id': !exists(json, 'prev_token_id') ? undefined : json['prev_token_id'],
        'oid': !exists(json, 'oid') ? undefined : json['oid'],
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'person_type': !exists(json, 'person_type') ? undefined : PersonTypeFromJSON(json['person_type']),
        'first_token': !exists(json, 'first_token') ? undefined : json['first_token'],
        'authentications': !exists(json, 'authentications') ? undefined : ((json['authentications'] as Array<any>).map(AuthenticationFromJSON)),
        'authenticated_methods': !exists(json, 'authenticated_methods') ? undefined : ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'groups_claim_name': !exists(json, 'groups_claim_name') ? undefined : json['groups_claim_name'],
        'prev_anonymous_person_id': !exists(json, 'prev_anonymous_person_id') ? undefined : json['prev_anonymous_person_id'],
    };
}

export function UserTokenAllOfToJSON(value?: UserTokenAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prev_token_id': value.prev_token_id,
        'oid': value.oid,
        'person_id': value.person_id,
        'person_type': PersonTypeToJSON(value.person_type),
        'first_token': value.first_token,
        'authentications': value.authentications === undefined ? undefined : ((value.authentications as Array<any>).map(AuthenticationToJSON)),
        'authenticated_methods': value.authenticated_methods === undefined ? undefined : ((value.authenticated_methods as Array<any>).map(FactorMethodToJSON)),
        'groups_claim_name': value.groups_claim_name,
        'prev_anonymous_person_id': value.prev_anonymous_person_id,
    };
}

